import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day2, time goes quick",
  "description": "",
  "published": "2009-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day2-time-goes-quick/swizec/799"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night was a bit unproductive because I fell asleep smack in the middle of inspiration and managed to write less than 300 words. The funny thing now is that there are already two days of writing behind us and I've not even fulfilled the quota of one :D`}</p>
    <p>{`That's right, only 920 words of garbage in two whole days!`}</p>
    <blockquote>
      <p parentName="blockquote">{`It was a cold November morning. An early snow covered everything in twenty centimeters of white fluff last night and Moe was caught completely by surprise. His shoes were old and torn; his coat was really just a warm ... ish ... sweater he`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      